import apiClient from './client';
import type { Trasportatore, TrasportatoreList } from '../types/trasportatore';

export interface TrasportatoriFilters {
  page?: number;
  limit?: number;
  search?: string;
}

export interface TrasportatoreCreatePayload {
  ragione_sociale: string;
  numero_iscrizione_anga: string;
  data_rilascio: string;
  categorie_classe: string;
  piva?: string | null;
  referente?: string | null;
  contatti?: string | null;
}

export type TrasportatoreUpdatePayload = Partial<TrasportatoreCreatePayload>;

export async function listTrasportatori(filters?: TrasportatoriFilters): Promise<TrasportatoreList> {
  const params: Record<string, string> = {};
  if (filters?.page != null) params['page'] = String(filters.page);
  if (filters?.limit != null) params['limit'] = String(filters.limit);
  if (filters?.search) params['search'] = filters.search;
  const { data } = await apiClient.get<TrasportatoreList>('/api/trasportatori', { params });
  return data;
}

export async function getTrasportatore(id: string): Promise<Trasportatore> {
  const { data } = await apiClient.get<Trasportatore>(`/api/trasportatori/${id}`);
  return data;
}

export async function createTrasportatore(payload: TrasportatoreCreatePayload): Promise<Trasportatore> {
  const { data } = await apiClient.post<Trasportatore>('/api/trasportatori', payload);
  return data;
}

export async function updateTrasportatore(id: string, payload: TrasportatoreUpdatePayload): Promise<Trasportatore> {
  const { data } = await apiClient.patch<Trasportatore>(`/api/trasportatori/${id}`, payload);
  return data;
}

export async function deleteTrasportatore(id: string): Promise<void> {
  await apiClient.delete(`/api/trasportatori/${id}`);
}
